import { Backdrop, Box, Card, CardContent, CardHeader, Fade, Grid, Modal, TextField, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { BulkReportRecord, BulkReportRecordEmailPreview, } from '../store/types';
import WO2Button from 'src/common/components/button/Button';

interface Props {
    record: BulkReportRecord;
    isOpen: boolean;
    handleClose: () => void;
    fetchEmailPreview: ({ batchId, recordIndex }: { batchId: string; recordIndex: number }) => void;
    emailPreview?: BulkReportRecordEmailPreview;
}

export const ReportingBatchEmailPreviewModal = (props: Props): JSX.Element | null => {
    const { batchId, recordIndex, clientName } = props.record;

    useEffect(() => {
        if (props.isOpen && batchId && recordIndex !== undefined) {
            props.fetchEmailPreview({ batchId, recordIndex });
        }
    }, [props.isOpen]);

    return (
        <Modal
            aria-labelledby="email-preview-modal-title"
            aria-describedby="email-preview-modal-description"
            open={props.isOpen}
            onClose={props.handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{ timeout: 500 }}
        >
            <Fade in={props.isOpen}>
                <Card
                    elevation={0}
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        padding: 2,
                        minWidth: 350,
                        maxWidth: 850,
                        height: '80vh',
                        overflowY: 'auto',
                        width: '100%',
                    }}
                >
                    <CardHeader title={<Typography variant="h3">Email Preview for {clientName}</Typography>}>
                    </CardHeader>
                    <CardContent
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            height: 'calc(100% - 64px)', // Subtracting the height of CardHeader
                            overflowY: 'auto',
                            width: '100%',
                        }}
                    >
                        <Grid container direction="column" spacing={2} padding={1}>
                            <Grid item container direction="column" spacing={2} padding={1}>
                                <Grid item>
                                    <TextField fullWidth disabled multiline variant="outlined" label="From" value={props.emailPreview?.from ?? ''} />
                                </Grid>
                                <Grid item>
                                    <TextField fullWidth disabled multiline variant="outlined" label="To" value={props.emailPreview?.to.join(', ') ?? ''} />
                                </Grid>
                                <Grid item>
                                    <TextField fullWidth disabled multiline variant="outlined" label="CC" value={props.emailPreview?.cc?.join(', ') ?? ''} />
                                </Grid>
                                <Grid item>
                                    <TextField fullWidth disabled multiline variant="outlined" label="Subject" value={props.emailPreview?.subject ?? ''} />
                                </Grid>
                                <Grid item sx={{ color: 'rgba(0, 0, 0, 0.38)' }}>
                                    <Box
                                        sx={{
                                            width: '100%',
                                            padding: '16.5px 14px',
                                            border: '1px solid rgba(0,0,0,0.23)',
                                            borderRadius: '4px',
                                            fontSize: '16px',
                                            lineHeight: 1.5,
                                        }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: props.emailPreview?.body ?? '' }} />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid item container justifyContent="flex-end">
                                <Grid item>
                                    <WO2Button variant="contained" onClick={props.handleClose}>
                                        Close
                                    </WO2Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Fade>
        </Modal>
    );
};
